<template>
  <PageTemplate :loading="loading" alternative>
    <Slides />
    <About />
    <Protocol />
    <BlueProtocol />
    <CincinnatiScale />
    <Questions />
    <Footer />
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import Slides from "../../sections/angels/Slides.vue";
import About from "../../sections/angels/About.vue";
import Protocol from "../../sections/angels/Protocol.vue";
import BlueProtocol from "../../sections/angels/BlueProtocol.vue";
import CincinnatiScale from "../../sections/angels/CincinnatiScale.vue";
import Questions from "../../sections/angels/Questions.vue";
import Footer from "../../sections/angels/Footer.vue";

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest("informationsAngels")
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    PageTemplate,
    Slides,
    About,
    Protocol,
    BlueProtocol,
    CincinnatiScale,
    Questions,
    Footer,
  },
};
</script>

<style>
@font-face {
  font-family: "Audacity Script";
  src: url("/fonts/audacity/AudacityScript.eot");
  src: url("/fonts/audacity/AudacityScript.eot?#iefix")
      format("embedded-opentype"),
    url("/fonts/audacity/AudacityScript.woff2") format("woff2"),
    url("/fonts/audacity/AudacityScript.woff") format("woff"),
    url("/fonts/audacity/AudacityScript.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.font-audacity {
  font-family: "Audacity Script" !important;
}

.font-montserrat {
  font-family: "Montserrat", sans-serif !important;
}
</style>
